var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-718.000000, -970.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Private",
    transform: "translate(119.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(14.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47826087,5.56521739 L3.47826087,3.82608696 C3.47826087,2.48352696 4.57048348,1.39130435 5.91304348,1.39130435 C7.25560348,1.39130435 8.34782609,2.48352696 8.34782609,3.82608696 L8.34782609,5.56521739 L9.73913043,5.56521739 L9.73913043,3.82608696 C9.73913043,1.71637217 8.02275826,0 5.91304348,0 C3.8033287,0 2.08695652,1.71637217 2.08695652,3.82608696 L2.08695652,5.56521739 L3.47826087,5.56521739 Z",
    id: "Path",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1304348,16 L0.695652174,16 C0.311453913,16 0,15.6885461 0,15.3043478 L0,6.26086957 C0,5.8766713 0.311453913,5.56521739 0.695652174,5.56521739 L11.1304348,5.56521739 C11.514633,5.56521739 11.826087,5.8766713 11.826087,6.26086957 L11.826087,15.3043478 C11.826087,15.6885461 11.514633,16 11.1304348,16 Z",
    id: "Path",
    fill: "#EFD358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30434783,9.73913043 C7.30434783,8.97072348 6.68145043,8.34782609 5.91304348,8.34782609 C5.14465739,8.34782609 4.52173913,8.97072348 4.52173913,9.73913043 C4.52173913,10.2528035 4.80328696,10.6964591 5.2173913,10.9374574 L5.2173913,13.2173913 L6.60869565,13.2173913 L6.60869565,10.9374574 C7.02282087,10.6964383 7.30434783,10.2528035 7.30434783,9.73913043 Z",
    id: "Path",
    fill: "#A58C21"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryLock);
export default __webpack_public_path__ + "static/media/category_lock.2c2a921d81ae471eae228e8600a502a1.svg";
export { ForwardRef as ReactComponent };